<template>
  <div class="xy-dialog">
    <div class="xy-dialog-container" :style="containerStyle">
      <xyComponent v-for="element in elements" :element="element" :key="element.uuid" :language="props.language" />
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, ref, computed } from 'vue'
import { info, defaultProps } from './config'
import xyComponent from '@/packages/components/xy-component.vue'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const elements = ref([])

const containerStyle = computed(() => {
  const style = {}
  const contentWidht = window.innerWidth || 750
  const contentHeight = window.innerHeight || 1334
  let scale = 1
  let ratio = contentWidht / 750
  // 判断高度是否超出
  if (Math.round(1334 * ratio) > contentHeight) {
    // 高度超出，获取高度缩放的比例
    scale = contentHeight / (1334 * ratio)
    // 顶部距离置顶
    const top = (contentHeight * (1 - scale)) / 2
    style.top = `-${top}px`
  } else {
    scale = 1
  }
  style.transform = `scale(${scale})`
  return style
})

const setChilderen = (nodes) => {
  if (!nodes || !nodes.length) {
    elements.value = []
    return
  }
  nodes.forEach((node) => {
    node.style = {
      ...node.style,
      position: 'absolute'
    }
  })
  elements.value = nodes
}
onBeforeMount(() => {
  setChilderen(props.element.nodes)
})
</script>

<style lang="scss" scoped>
.xy-dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: hidden;
  background: rgba($color: #000000, $alpha: 0.85);
  display: block;
  .xy-dialog-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
    top: 0;
  }
}
</style>
